<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
      <div slot="header">
        <h5 class="modal-title">{{$t('codici_sconto')}}</h5>
      </div>
      <div slot="body">
        <div class="container">
          <div class="row pt-2">
            <div class="col-12">
              <form @submit.prevent="applyCoupon">
                <p class="f13 mb-1"><b>{{ $t('carrello_ins_sconto') }}</b></p>
                <input
                  type="text"
                  class="form-control text-uppercase mb-3"
                  :placeholder="$t('ordine_sconto')"
                  v-model="coupon_text"
                  :disabled="loading_coupons"
                >

              </form>
            </div>
            <div class="col-12 py-4 text-center" v-if="loading_coupons">
              <span class="spinner-grow spinner-grow-sm mr-2" role="status" aria-hidden="true"></span>
            </div>
            <template v-else>
              <div class="col-12 mb-3" v-for="coupon in this.discount_codes" :key="coupon.id || coupon.nome">
                <button type="button" class="a1 text-left p-0 border-0 bg-transparent w-100" @click="selectCoupon(coupon)">
                  <div class="codici-sconto d-flex align-items-center">
                    <div class="vertical-line"></div>
                    <div class="p-3">
                      <p class="mt-1 mb-2"><b class="green f22"><i>{{ getCouponDiscount(coupon) }}</i></b></p>
                      <p v-if="coupon.ordine_minimo">
                        {{ $t('sconti.ordine_minimo') }} {{
                          coupon.ordine_minimo.toFixedGood(2)
                        }} {{ locale_currency }}
                      </p>
                      <p v-if="!coupon.dal && !coupon.al">
                        {{ $t('sempre_valido') }}
                      </p>
                      <p v-else-if="moment(coupon.dal).isSame(moment(coupon.al), 'day')">
                        {{ $t('valido_il') }} {{ moment(coupon.dal).format('DD/MM') }}
                      </p>
                      <p v-else>
                        {{ $t('valido_dal') }} {{ moment(coupon.dal).format('DD/MM') }}
                        {{ $t('al') }} {{ moment(coupon.al).format('DD/MM') }}
                      </p>
                      <p class="f16 mt-3 mb-0 ellipsis">
                        <b>{{ coupon.nome }}</b>
                      </p>
                      <div class="codici-sconto-dettaglio gray" v-if="!coupon.tipi_orario_completi">
                        {{ $t('attivo_solo_per') }}: {{ getCouponTipiOrarioText(coupon) }}
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          type="button"
          class="btn btn-primary"
          @click="applyCoupon"
          :disabled="loading_coupons || couponCheck || !coupon_text.trim().length"
        >
          <span class="spinner-grow spinner-grow-sm mr-2" role="status" aria-hidden="true"
                v-if="couponCheck"></span>
          {{ $t('btn_applica') }}
        </button>
      </div>
    </modal>
</template>

<script>
import Modal from '../../partials/Modal';
import { mapState, mapGetters } from 'vuex';
import { getCoupons } from '../../../api/account';

export default {
    name: "ModalSelectDiscount",
    components: {Modal},
    props: ['couponTemp', 'couponCheck'],

  data: function () {
    return {
      discount_codes: [],
      coupon_text: this.couponTemp ? this.couponTemp.toUpperCase() : '',
      loading_coupons: true
    }
  },
  created() {
    this.fetchCoupons();
  },
  computed: {
    ...mapState('localization', {
      language: (state) => state.language
    }),
    ...mapState('restaurant', {
      id_ristorante: (state) => state.id,
      locale: (state) => state.locale
    }),
    ...mapGetters('restaurant', {
      locale_currency: 'localeCurrency',
      getServiceInfo: 'serviceInfo'
    }),
    ...mapState('auth', {
      user: state => state
    }),
  },
  watch: {
    language: function () {
      this.fetchCoupons();
    }
  },
  methods: {
    fetchCoupons: function () {
      this.loading_coupons = true;
      getCoupons(this.language, {
        id_ristorante: this.id_ristorante,
        id_locale: this.locale.id,
        api_key: this.user.api_key,
        f_nascosto: 0
      }).then((response) => {
        this.discount_codes = response.codici_sconto;
      }).catch(({messages}) => {
        alert(messages.join('\n'))
      }).finally(() => {
        this.loading_coupons = false;
      });
    },
    selectCoupon: function (coupon) {
      this.coupon_text = coupon.nome;
    },
    applyCoupon: function () {
      this.$emit('apply', {
        couponText: this.coupon_text.trim().toUpperCase(),
        coupons: this.discount_codes
      });
    },
    getCouponDiscount: function (coupon) {
      if (coupon.valore || !coupon.f_spedizione_gratis) {
        if (coupon.tipo === "VALORE") {
          return this.$t('sconto') + ' ' + coupon.valore.toFixedGood(2) + ' ' + this.locale_currency;
        }

        return coupon.valore + '%';
      }

      if (!!coupon.f_spedizione_gratis) {
        return this.$t('spedizione_gratuita');
      }

      return null;
    },
    getCouponTipiOrarioText: function (coupon) {
      return coupon.tipi_orario.length ?
          coupon.tipi_orario.map(tipoOrario => this.getServiceInfo(tipoOrario.toUpperCase(), null).nome).join(" - ")
          :
          "N/A";
    }
  }
}
</script>
